import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-26_02",
  version: "2026.06.26",
  date: "26 Jun 2026",
  sinceCommit: "3f8830d",
  gameplay: [
    {
      text: "**Achievement titles** — hard achievements now grant cosmetic titles (prefix or suffix) you can equip from your profile. Titles show in lobbies, above your wizard, on the scoreboard, and in match results.",
    },
    {
      text: "**Immortal** — new PvE feat: complete a full Void Gauntlet run with no party deaths. Earns the title *the Immortal*.",
    },
  ],
  skills: [],
};
